import { Button, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { messageSVC } from "message/service"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { LinearLoader } from "ui/components/LinearLoader"
import { IUserImpersonatorHydrated, IUserInfo } from "user/model"
import { getAvailableImpersonators, impersonate } from "user/tools/impersonate"
import { AvailableImpersonatorsPopup } from "./AvailableImpersonatorsPopup"

interface IAvailableImpersonatorsProps {
  selfUserInfo: IUserInfo
}

const AvailableImpersonatorsFn = ({ selfUserInfo }: IAvailableImpersonatorsProps) => {
  const [availableImpersonators, setAvailableImpersonators] = React.useState<IUserImpersonatorHydrated[] | null>(null)
  const [hasLoadingError, setHasLoadingError] = React.useState(false)
  const [isPopupOpened, setIsPopupOpened] = React.useState(false)
  React.useEffect(() => {
    getAvailableImpersonators()
      .then(impersonators => setAvailableImpersonators(impersonators))
      .catch(error => {
        console.error("Unable to fetch available impersonators", error)
        messageSVC.error(translate("user.impersonate.available.loading.error"))
        setHasLoadingError(true)
      })
  }, [])
  const isEmpty = !availableImpersonators || availableImpersonators.length === 0
  return (
    <FlexBox id="available-impersonate-users" vertical fullWidth>
      {hasLoadingError ? (
        <Typography color="error" fontSize=".9rem">
          {translate("user.impersonate.available.loading.error")}
        </Typography>
      ) : availableImpersonators === null ? (
        <LinearLoader />
      ) : (
        <>
          <FlexBox fullWidth wrap jc="space-between">
            <Typography
              id={isEmpty ? "available-impersonator-empty" : "available-impersonator-title"}
              color={isEmpty ? "textSecondary" : "textPrimary"}
              fontSize=".9rem"
              fontWeight={500}>
              {translate(isEmpty ? "user.impersonator.available.empty" : "user.impersonator.take.title")}
            </Typography>
            <Button
              id="impersonator-take-button"
              variant="contained"
              disabled={isEmpty}
              onClick={() => setIsPopupOpened(true)}>
              {translate("user.impersonator.take.button")}
            </Button>
          </FlexBox>
          {isPopupOpened && (
            <AvailableImpersonatorsPopup
              availableImpersonators={availableImpersonators}
              onClose={(impersonator?: IUserImpersonatorHydrated) => {
                if (!impersonator) {
                  setIsPopupOpened(false)
                } else {
                  impersonate(impersonator.email)
                }
              }}
            />
          )}
        </>
      )}
    </FlexBox>
  )
}

export const AvailableImpersonators = connect(
  (state: IRootState): IAvailableImpersonatorsProps => ({
    selfUserInfo: state.user
  })
)(AvailableImpersonatorsFn)
